/* eslint-disable space-before-function-paren */
/* eslint-disable no-extra-parens */
// -- Imports -- //
require('onbrandutilityfunctions/build/conditional-babel-polyfill.bundle.js'); // use all the things!
const onbrandUtilityFunctions = require('onbrandutilityfunctions');
const devOptions = require('./dev-options.js'); //Development options
const onbrandScss = require('./onbrand.scss'); //Onbrand styles
const clientScss = require('./client/client.scss'); //client styles
const htmlHeader = require('./includes/header.html');
const htmlFooter = require('./includes/footer.html');

const customjs = require('./scriptPartials/streamLevel.js');

const { tileTagging } = require('./scriptPartials/tileTagging');
// const { twitterRSS } = require('./scriptPartials/twitterRSS');
const { moveFlipbookText } = require('./scriptPartials/moveFlipbookText');
const { insertBackToTop } = require('./scriptPartials/insertBackToTop');
const { addCarouselGradient } = require('./scriptPartials/addCarouselGradient');
// const { quoteCTA } = require('./scriptPartials/quoteCTA');
const { adjustPDFButtons, handleFlipbookButton, handleGatedCTASubmit } = require('./scriptPartials/adjustPDFButtons');
const { moveLink } = require('./scriptPartials/moveLink');
const { moveCarouselButton } = require('./scriptPartials/moveCarouselButtons');
const { handleMobileMenu, updateHomeIcon } = require('./scriptPartials/handleMobileMenu');
const { adjustReco } = require('./scriptPartials/adjustReco');
const {
    customLoopFuncCall,
    openDropdown,
    openMobileDropdown,
    bindNav,
    customHeaders,
    checkStream,
    replaceBreadCrumbs,
    searchClose,
} = require('./scriptPartials/tileCustomization.js');
const { moveParagraph } = require('./scriptPartials/moveParagraph.js');
const { blockCtaFix } = require('./scriptPartials/blockCtaFix.js');



module.exports = {
    initOnbrand: function initOnbrand(translations, production) {
        // -- Startup -- //
        production ? null : onbrandUtilityFunctions.devMode(devOptions);
        $('body').prepend(htmlHeader(translations));
        $('body').append(htmlFooter(translations));

        window.onbrandLoaded = false;

        // old time embed error throw "fix" (TODO: make this better)
        onbrandUtilityFunctions.legacyEmbedTileFix();
        // Remove the "touch" class on touchscreen laptops
        onbrandUtilityFunctions.removeTouchForLaptops();
        // Remove the hub function updateOverlaySize
        onbrandUtilityFunctions.overrideHubFuctions();
        // Adds body classes for content type (blogPost, youtube, sales-stream etc)
        onbrandUtilityFunctions.helpfulClasses();
        // Rebuild the share widget for the top-nav
        onbrandUtilityFunctions.fixShareWidgetImproved();
        // warns you if your query string is missing.
        onbrandUtilityFunctions.noQueryStringSafeguard();
        // makes the reco engine sticky to the target / top of screen
        onbrandUtilityFunctions.recoEnginePositioning('.top-nav');

        // -- Hub Events -- //
        Hubs.Events.on('load', () => {
                if (!window.onbrandLoaded) {
                    // Add your onloads here...
                    searchClose();
                    customHeaders();
                    bindNav();
                    tileTagging();
                    //twitterRSS();
                    moveFlipbookText();
                    insertBackToTop();
                    addCarouselGradient();
                    //quoteCTA();
                    adjustPDFButtons();
                    moveLink();
                    moveCarouselButton();
                    handleMobileMenu();
                    updateHomeIcon();
                    adjustReco();
                    moveParagraph();
                    customjs.test();
                    handleFlipbookButton();
                    blockCtaFix(80);
                    // end your onloads before here...
                    window.onbrandLoaded = true;
                    handleMobileMenu();
                }
            })
            .on('itemsLoaded', (itemIds, selectors) => {
                tileTagging();
                moveLink();
            }) //eslint-disable-line no-unused-vars

        .on('resize', () => {
                // adjust side cta or addThis by passing a number into the function
                // eg onbrandUtilityFunctions.sideCtaFix(150); will push the side cta down by 150px, do the same for on scroll
            })
            .on('scroll', () => {
                onbrandUtilityFunctions.sideCtaFix();
                blockCtaFix(80);
                adjustReco();
            })
            .on('ctaActivate', (ctaId) => {}) //eslint-disable-line no-unused-vars
            .on('ctaFormSubmitSuccess', (ctaId, mappedData, ctaName) => {
                handleGatedCTASubmit();
            }); //eslint-disable-line no-unused-vars

        // The new hub events can trigger before cihost scripts are loaded.
        // This will ensure your scripts fire no matter what, but not more than once for 'load'.
        if (!window.onbrandLoaded) {
            Hubs.Events.trigger('load');
        }
    },
};


// WEBPACK FOOTER //
// ./onbrand.js